import React, { FunctionComponent } from 'react';
import { AlertTriangle } from 'lucide-react';
import { cn } from '@companion-professional/webutils';
import { Alert, AlertDescription, AlertTitle } from '../Alert';

interface ErrorAlertProps {
  message?: string;
  title?: string;
  className?: string;
}

// ErrorAlert is a component that displays an commonly styled error message.
export const ErrorAlert: FunctionComponent<ErrorAlertProps> = ({ message, title, className }) => {
  // If there is no message or title, don't show anything.
  if (!message && !title) {
    return null;
  }

  if (typeof message !== 'string') {
    // Even though we have the typescript annotation for message, we should still check it at runtime because it's
    // possible that some 3rd party library could pass in a non-string value (e.g. the Mux UpChunk library seems to on
    // occasion pass an array).
    console.error('ErrorAlert message must be a string', message);
    message = 'An error occurred';
  }

  return (
    <Alert
      variant="destructive"
      className={cn('flex min-w-72 max-w-xl flex-row items-center gap-4 bg-widget shadow-card', className)}
    >
      <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-destructive/10">
        <AlertTriangle className="h-5 w-5" />
      </div>
      <div>
        {title ? <AlertTitle>{title}</AlertTitle> : null}
        {message ? <AlertDescription className="text-on-widget">{message}</AlertDescription> : null}
      </div>
    </Alert>
  );
};
